export class ConditionUnitRangeSettingModel {
    public systemTypeConditionId: number;
}